import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import _head from 'lodash/head';
import _isEmpty from 'lodash/isEmpty';
import { DEFAULT_CONTAINER_CLASS_NAME } from './PriceRange.constants';
import { createComponent } from '../../../foundation/services/components';
import { ComponentPropType } from '../../../foundation/types/component';
import { createLabeledPriceRangeDisplay, pricesHaveLabels, getPriceRangeDisplay, createPrices } from '../../services/price';
import { PricePropType, PriceRangeSettingsPropType, PriceRangeSettingsPropTypeDefault } from '../../types';
import Price from '../Price';
import './PriceRange.css';
var defaultProps = {
  prices: [],
  settings: PriceRangeSettingsPropTypeDefault,
  priceKey: 'amount',
  as: 'span'
};
export default function PriceRange(_ref) {
  var prices = _ref.prices,
    settings = _ref.settings,
    priceKey = _ref.priceKey,
    as = _ref.as;
  var labelDelimiter = settings.labelDelimiter,
    allowMixedFormat = settings.allowMixedFormat;
  var finalPrices = createPrices(prices, priceKey);
  function wrapPriceRange(priceRange) {
    if (as) {
      return createComponent(as, {
        className: DEFAULT_CONTAINER_CLASS_NAME,
        children: priceRange
      });
    }
    return priceRange;
  }
  if (_isEmpty(finalPrices)) {
    return null;
  }
  if (finalPrices.length === 1) {
    var singlePrice = _head(finalPrices);
    return /*#__PURE__*/React.createElement(Price, _extends({}, singlePrice, settings));
  }
  if (pricesHaveLabels(finalPrices)) {
    if (!allowMixedFormat) {
      return wrapPriceRange('');
    }
    return wrapPriceRange(createLabeledPriceRangeDisplay(finalPrices, labelDelimiter));
  }
  return wrapPriceRange(getPriceRangeDisplay(finalPrices, settings));
}
PriceRange.defaultProps = defaultProps;